// extracted by mini-css-extract-plugin
export var flagListStyle = "search_jobs_result_flag_list-module--flagListStyle--q2Xn2";